// extracted by mini-css-extract-plugin
export default {"singleEntry":"PtQbf","selectedEntry":"Zg7Ka","entryName":"u02KK","selected":"bfyE6","stakeNameContainer":"cZApo","maxWinning":"qM6hl","amount":"ITHZ0"};